<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-between" style="display: none">
    <p class="flex flex-wrap w-full justify-center items-center">
      <span class="mr-4 hidden"
        >COPYRIGHT &copy; {{ new Date().getFullYear() }} Palace of Kebap
        <!-- <a href="https://j-ull.com" target="_blank" rel="nofollow">JULL</a> --></span
      >
      <vs-button class="ml-4" type="flat" @click="popupIngredients = true"
        >* Infos zu Zutaten</vs-button
      >
      <vs-button class="ml-4" type="flat" @click="popupImprintActive = true"
        >Impressum</vs-button
      >
      <vs-button
        class="ml-4"
        type="flat"
        @click="popupPrivacyStatementActive = true"
        >Datenschutz</vs-button
      >
      <vs-button
        class="ml-4"
        type="flat"
        @click="popupTermsAndConditionsActive = true"
        >AGBs</vs-button
      >
    </p>
    <!-- <span class="md:flex hidden items-center">
            <span>Programmed by  <a href="https://j-ull.com" target="_blank" rel="nofollow">JULL</a></span>
           
        </span> -->
    <vs-popup
      fullscreen
      title="Infos zu Zutaten"
      :active.sync="popupIngredients"
    >
      <ingredients></ingredients>
    </vs-popup>
    <vs-popup fullscreen title="Impressum" :active.sync="popupImprintActive">
      <imprint></imprint>
    </vs-popup>
    <vs-popup
      fullscreen
      title="Datenschutzbestimmungen"
      :active.sync="popupPrivacyStatementActive"
    >
      <privacy-statement></privacy-statement>
    </vs-popup>
    <vs-popup
      fullscreen
      title="Allgemeine Geschäftsbedingungen"
      :active.sync="popupTermsAndConditionsActive"
    >
      <terms-and-conditions></terms-and-conditions>
    </vs-popup>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      popupIngredients: false,
      popupImprintActive: false,
      popupPrivacyStatementActive: false,
      popupTermsAndConditionsActive: false,
    };
  },
  name: "the-footer",
};
</script>
